import { PredictionsActionsTypes } from './action-types';
export const storePredictedCompanySize = companySize => dispatch => {
  dispatch({
    type: PredictionsActionsTypes.SetCompanyInfoPrediction,
    payload: companySize
  });
};